import { render, staticRenderFns } from "./turnstile.vue?vue&type=template&id=89a205cc&scoped=true&"
import script from "./turnstile.vue?vue&type=script&lang=js&"
export * from "./turnstile.vue?vue&type=script&lang=js&"
import style0 from "./turnstile.vue?vue&type=style&index=0&id=89a205cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89a205cc",
  null
  
)

export default component.exports